import React, { useContext, useEffect } from "react";
import AttemptsTable from "../components/attempts/AttemptsTable";
import { AttempsContext } from "../context/AttemptsContext";
import moment from "moment";

const MisEvaluaciones = () => {
  const { attempts, getUserAttempts } = useContext(AttempsContext);

  useEffect(() => {
    getUserAttempts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finalExams = Array.isArray(attempts)
    ? attempts
        .filter(
          ({ test }) =>
            test?.course_id !== null && test?.course_id !== undefined
        )
        .sort((a, b) => moment(a.createdAt).diff(moment(b.createdAt)))
    : attempts;

  return (
    <div className="container-fluid pt-4">
      <div className="row mx-0 align-items-center mb-3">
        <div className="container-fluid">
          <h2>Mis Evaluaciones</h2>
          <AttemptsTable attempts={finalExams} />
        </div>
      </div>
    </div>
  );
};

export default MisEvaluaciones;
